<div class="assign-role">
  <div class="flex flex-row justify-between items-center">
    <div class="fs-24 fw-700 mat-subtitle-2 mb-0">{{'GROUPS.ASSIGN_ROLE' | transloco}}</div>
    <mat-icon class="justify-items-end cursor-pointer icon-lg" (click)="closeSidenav()" svgIcon="close"></mat-icon>
  </div>
  <mat-divider class="neutral-2 mt-20"></mat-divider>
  <div *ngIf="!isLoading; else loader" class="mb-12 mt-24 selection pr-8" [ngClass]="{'disabled': apiLoading}">
    <div class="mb-8 flex">
      <span class="mat-subtitle-2 fs-16 fw-500 mb-8">{{'GROUPS.GROUP_NAME' | transloco}}:</span>
      <span class="ml-8 fw-500">{{name}}</span>
    </div>
    <div class="mb-16 flex">
      <span class="mat-subtitle-2 fs-16 fw-500 mb-8">{{'GROUPS.DESCRIPTION' | transloco}}:</span>
      <span class="ml-14 fw-500">{{description ? description : '-'}}</span>
    </div>

    <div class="flex flex-row justify-start items-center mb-8">
      <label class="mat-subheading-2 mb-0 fs-12 fw-700">{{'GROUPS.TENANT' | transloco | uppercase }}</label>
      <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'GROUPS.TENANT' | transloco"
        matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
    </div>
    <!-- <mat-select class="fw-500 fs-16 mr-24 pt-0 pr-0 group-tenant mb-24" [placeholder]="'GROUPS.SELECT_TENANT' | transloco"
      [(value)]="selectedTenant" panelClass="group-tenant" (selectionChange)="tenantSelectionChanged($event.value)">
      <mat-option *ngFor="let tenant of tenants" [value]="tenant" [title]="tenant.tenantId | titlecase">{{ tenant.tenantId |
        titlecase}}</mat-option>
    </mat-select> -->
    <mat-select class="fw-500 pr-0 fs-16 tenant-list mt-16 mr-24 mb-24 group-tenant" [placeholder]="'GROUPS.SELECT_TENANT' | transloco"
      panelClass="group-tenant" (selectionChange)="tenantSelectionChanged($event.value)" (closed)="resetDropdown()">
      <div class="flex relative m-8"><input [(ngModel)]="dropdownSearchValue"
          (ngModelChange)="searchChanged(dropdownSearchValue)" class="fw-400 h-34 search-text pl-12"
          placeholder="{{'SEARCH.SEARCH' | transloco}}" type="text">
        <span (click)="searchChanged(dropdownSearchValue)" class="cursor-pointer absolute"><mat-icon
            class="icon-md icon-color search-icon mt-4" svgIcon="search"></mat-icon></span>
      </div>
      <mat-option *ngIf="!tenants || tenants?.length === 0">
        <div class="ml-16 mr-16 mt-8 mb-8">
          {{'MY_ACCOUNT.NO_TENANT_FOUND' | transloco}}</div>
      </mat-option>
      <ng-container *ngFor="let tenant of tenants; let i = index">
        <mat-option [value]="tenant">{{tenant.tenantId}}</mat-option>
        <mat-divider *ngIf="i < tenants.length - 1" class="neutral-2 mb-4"></mat-divider>
      </ng-container>
    </mat-select>

    <div *ngIf="selectedTenant" class="roles-section">
      <div class="flex justify-between items-center roles-header pt-4 pb-4 pr-8 pl-20">
        <div class="mat-subtitle-2 fw-600">{{'GROUPS.ROLES' | transloco }}</div>
        <div class="flex flex-row justify-between items-center search-wrapper">
          <app-search-filter (keyup)="searchRole($event)" [placeholder]="'GROUPS.SEARCH_ROLE'"></app-search-filter>
        </div>
      </div>
      <div class="pt-20 pl-20 pr-16">
        <div class="p-8 mr-24 role flex justify-between items-center fw-500 mb-16" [ngClass]="{'hidden': role.hidden}" *ngFor="let role of filteredRoles">
          <div class="flex items-center" [ngClass]="{ 'disable': role.disable}">
            <mat-icon [svgIcon]="role?.selected ? 'check_box' : 'check_box_outline_blank'" (click)="selectRole(role)" class="icon-md-1 mr-12"></mat-icon>
            <span>{{ role?.name | titlecase }}</span>
          </div>
          <div class="view-permission cursor-pointer" (click)="viewPermissions(role)">{{'GROUPS.VIEW_PERMISSIONS' | transloco}}</div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #loader>
    <div *ngIf="isLoading" class="flex spinner-container spinner">
      <mat-spinner diameter="24"
        color="primary"
        mode="indeterminate">
      </mat-spinner>
    </div>
  </ng-template>

  <div *ngIf="apiLoading">
    <mat-card class="flex spinner-container load-spinner">
      <mat-spinner diameter="24"
        color="primary"
        mode="indeterminate">
      </mat-spinner>
    </mat-card>
  </div>

  <mat-divider *ngIf="!isLoading" class="neutral-2 mb-12"></mat-divider>
  <div *ngIf="!isLoading" class="flex flex-row justify-end w-100-percent" [ngClass]="{'disabled': apiLoading}">
    <button type="cancel" class="white" (click)="closeSidenav()">{{'DIALOG.CANCEL' | transloco}}</button>
    <button type="submit" class="accent ml-12" (click)="submit()" [ngClass]="{'disabled': (!selectedTenant || selectedRoles?.length === 0)}">{{'TENANT_FORM.SUBMIT' | transloco}}</button>
  </div>
</div>
